<template>
  <div>
    <div class="relative !my-[-10rem]">
      <div class="flex relative w-full min-h-[20vh]">
        <div class="absolute bg-opacity-50 w-[300px] bg-white rounded-full aspect-square top-[30vh] left-[20vh]"/>
        <div class="absolute bg-opacity-50 w-[200px] bg-blue-500 rounded-full aspect-square"/>
        <div class="absolute bg-opacity-50 w-[200px] bg-sky-300 rounded-full aspect-square top-2 left-[55vh]"/>
        <div class="absolute bg-opacity-50 w-[200px] bg-sky-300 rounded-full aspect-square top-[60vh] left-[5vh]"/>
        <div class="absolute bg-opacity-50 w-[250px] bg-blue-500/20 rounded-full aspect-square top-[50vh] right-[20vh]"/>
        <div class="absolute bg-opacity-50 w-[200px] bg-sky-300 rounded-full aspect-square top-0 -right-[5vh]"/>
        <div class="absolute bg-opacity-50 w-[200px] bg-sky-300 rounded-full aspect-square top-[50vh] left-[15vh]"/>
        <div class="absolute bg-opacity-50 w-[200px] bg-sky-300 rounded-full aspect-square top-[50vh] left-[40vh]"/>
        <div class="absolute bg-opacity-50 w-[200px] bg-blue-500 rounded-full aspect-square right-0 bottom-0"/>
        <div class="absolute bg-opacity-30 w-[200px] bg-blue-400 rounded-full aspect-square right-[40%] top-[20%]"/>

        <div
          v-for="i in 28"
          :key="i"
          v-memo="[i]"
          class="backdrop-blur-xl blur-2xl -my-[20rem] flex-grow h-[200vh]"
          :class="{
            'max-md:hidden': i % 4
          }"
          />

        <div class="absolute inset-0 -my-[20rem] bg-slate-200/30"/>
      </div>
    </div>
  </div>
</template>
